import { attachmentGroupsFragment } from "./StudentAssignmentFragments";
import { gql } from "lib/apolloClient";

export const createAttachmentGroupsMutationV2 = gql`
  mutation createAttachmentGroupsV2($input: [AttachmentGroupInput!]) {
    platform {
      createAttachmentGroupsV2(input: $input) {
        response {
          ...attachmentGroupItem
        }
        warning
      }
    }
  }
  ${attachmentGroupsFragment.attachmentGroup}
`;
